// @flow

import * as React from "react";
import country_codes from "components/countries";

export type SelectorProps = {
  onChange: string => void,
  country_code: string
};

export const CountrySelector = (props: SelectorProps) => {
  return (
    <select
      onChange={(e: SyntheticInputEvent<HTMLSelectElement>) => {
        props.onChange(e.target.value);
      }}
      value={props.country_code}
      className={"form-control country_selector"}>
      {Object.keys(country_codes).map((key: string) => (
        <option key={key} value={key}>
          {country_codes[key]}
        </option>
      ))}
    </select>
  );
};

export function to_country_name(code: string): string {
  return country_codes[code];
}
